import request from '@/utils/request'



// 查询订单发货记录列表
export function listDelivery(query) {
  return request({
    url: '/biz/admin/order/delivery/list',
    method: 'get',
    params: query
  })
}

// 查询订单发货记录分页
export function pageDelivery(query) {
  return request({
    url: '/biz/admin/order/delivery/page',
    method: 'get',
    params: query
  })
}

// 查询订单发货记录详细
export function getDelivery(data) {
  return request({
    url: '/biz/admin/order/delivery/detail',
    method: 'post',
    data: data
  })
}


//物流信息
export function logisticsById(data) {
  return request({
    url: '/biz/admin/order/delivery/logistics/id',
    method: 'post',
    data: data
  })
}

export function logisticsByNo(data) {
  return request({
    url: '/biz/admin/order/delivery/logistics/no',
    method: 'post',
    data: data
  })
}


